import React, { Component } from 'react'
import Slider from 'react-slick'
import './HonorariaAnalysisMobile.sass'

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import PropTypes from 'prop-types'

class HonorariaAnalysisMobile extends Component {
  static propTypes = {
    teamMembers: PropTypes.array
  }

  constructor (props) {
    super(props)
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
    this.calculateNextPrevious = this.calculateNextPrevious.bind(this)

    this.state = {
      canGoNext: true,
      canGoPrevious: false
    }
  }

  calculateNextPrevious (slide) {
    this.setState({
      canGoNext: !(
        slide >=
        this.props.teamMembers.length - this.slider.props.slidesToShow
      ),
      canGoPrevious: !(slide <= 0)
    })
  }

  next () {
    this.slider.slickNext()
  }

  previous () {
    this.slider.slickPrev()
  }

  render () {
    const settings = {
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 1.2,
      slidesToScroll: 1,
      afterChange: this.calculateNextPrevious
    }

    return (
      <div className='mobile-honorariaAnalysis-slider-container'>
        <div className='mobile-honorariaAnalysis-labels'>
          <div className='honorariaAnalysis-table-cell-mobile'>Name</div>
          <div className='honorariaAnalysis-table-cell-mobile'>Position</div>
          <div className='honorariaAnalysis-table-cell-mobile'>Avg €</div>
          <div className='honorariaAnalysis-table-cell-mobile'>Diff. %</div>
        </div>
        <div className='mobile-honorariaAnalysis-slider'>
          <Slider ref={c => (this.slider = c)} {...settings}>
            {this.props.teamMembers.map((teamMember, index) => {
              return (
                <div className='mobile-honorariaAnalysis-slide' key={index}>
                  <div className='honorariaAnalysis-table-cell-mobile honorariaAnalysis-table-cell-mobile__name'>
                    {teamMember.fullName}
                  </div>
                  <div className='honorariaAnalysis-table-cell-mobile'>
                    {teamMember.position}
                  </div>
                  <div className='honorariaAnalysis-table-cell-mobile'>
                    {teamMember.average
                      ? Math.round(teamMember.average / 1e6).toLocaleString(
                          undefined,
                          {
                            maximumFractionDigits: 0,
                            minimumFractionDigits: 0
                          }
                        )
                      : '-'}
                  </div>
                  <div
                    className={`honorariaAnalysis-table-cell-mobile ${
                      teamMember.diff > 0 ? 'diff-positive' : 'diff-negative'
                    }`}
                  >
                    {teamMember.diff
                      ? teamMember.diff.toLocaleString(undefined, {
                          maximumFractionDigits: 2,
                          minimumFractionDigits: 2
                        })
                      : '-'}
                  </div>
                </div>
              )
            })}
          </Slider>
          <div className='slider-chevrons'>
            <button
              disabled={!this.state.canGoPrevious}
              onClick={this.previous}
            >
              <ChevronLeftIcon />
            </button>
            <button disabled={!this.state.canGoNext} onClick={this.next}>
              <ChevronRightIcon />
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default HonorariaAnalysisMobile
